import user from '@/core/user'

const functionsMap = {
  '$action$': (card) => card.Action,
  '$what$': (card) => ({ url: card.Url, text: card.What }),
  '$supplier$': (card) => ({ url: card.SupplierProfileUrl, text: card.SupplierName + (card.SupplierVCI > 0 ? (' (' + card.SupplierVCI + ')') : '') }),
  '$programName$': (card) => ({ url: card.ProgramUrl, text: card.ProgramName + ((card.InternalProgramId && (card.InternalProgramId !== '')) ? (', ' + card.InternalProgramId) : '') }),
  '$programLabel$': (card) => getProgramLabel()
}

// -----------------------------------------------------------------------------

const make = (icon, template) => ({ icon: icon, template: template })

function getProgramLabel() {
  let settings = user.getCompanySettings()
  return settings.ProgramLabel ? settings.ProgramLabel : 'Program'
}

// -----------------------------------------------------------------------------

/* eslint key-spacing: 0 */

export default {
  tokenize: (template, card) => template
    .split(' ')
    .map(token => functionsMap[token] ? functionsMap[token](card) : (' ' + token + ' ')),

  // -----------------------------------------------------------------------------

  default                    /**/: make('fa-envelope',          /**/ '$action$  $what$ for $supplier$ for $programName$'),

  // -----------------------------------------------------------------------------

  'EvedPayCard': {
    'EvedPay Card Activated' /**/: make('fa-credit-card',       /**/ 'EvedPay Card $what$ was activated for $programName$'),
    'EvedPay Card Approved'  /**/: make('fa-credit-card',       /**/ 'EvedPay Card $what$ was approved for $programName$'),
    'EvedPay Card Closed'    /**/: make('fa-credit-card',       /**/ 'EvedPay Card $what$ was closed for $programName$'),
    'EvedPay Card Rejected'  /**/: make('fa-credit-card',       /**/ 'EvedPay Card $what$ was declined for $programName$'),
    'EvedPay Card Declined'  /**/: make('fa-credit-card',       /**/ 'EvedPay Card $what$ was declined for $programName$'),
    'EvedPay Card Requested' /**/: make('fa-credit-card',       /**/ 'EvedPay Card $what$ was requested for $programName$')
  },

  'Invoice': {
    'Credit Invoice Issued'  /**/: make('fa-file-plus',         /**/ 'Credit invoice $what$ was submitted for $supplier$ for $programName$'),
    'Credit Received'        /**/: make('fa-envelope',          /**/ 'Credit was received for $what$ from $supplier$ for $programName$'),
    'Invoice Approved'       /**/: make('fa-file-check',        /**/ 'Invoice $what$ was approved for $supplier$ for $programName$'),
    'Invoice Cancelled'      /**/: make('fa-file-times',        /**/ 'Invoice $what$ was cancelled for $supplier$ for $programName$'),
    'Invoice Issued'         /**/: make('fa-inbox-out',         /**/ 'Invoice $what$ was submitted for $supplier$ for $programName$'),
    'Invoice Rejected'       /**/: make('fa-file-times',        /**/ 'Invoice $what$ was declined for $supplier$ for $programName$'),
    'Invoice Declined'       /**/: make('fa-file-times',        /**/ 'Invoice $what$ was declined for $supplier$ for $programName$')
  },

  'SupplierInvoice': {
    'Credit Invoice Issued'  /**/: make('fa-file-plus',         /**/ 'Credit invoice $what$ was submitted by $supplier$ for $programName$'),
    'Credit Received'        /**/: make('fa-envelope',          /**/ 'Credit was received for $what$ from $supplier$ for $programName$'),
    'Invoice Approved'       /**/: make('fa-file-check',        /**/ 'Invoice $what$ was approved for $supplier$ for $programName$'),
    'Invoice Cancelled'      /**/: make('fa-file-times',        /**/ 'Invoice $what$ was cancelled for $supplier$ for $programName$'),
    'Invoice Issued'         /**/: make('fa-inbox-in',          /**/ 'Invoice $what$ was submitted by $supplier$ for $programName$'),
    'Invoice Rejected'       /**/: make('fa-file-times',        /**/ 'Invoice $what$ was declined for $supplier$ for $programName$'),
    'Invoice Declined'       /**/: make('fa-file-times',        /**/ 'Invoice $what$ was declined for $supplier$ for $programName$')
  },

  'PO': {
    'Change Order Requested' /**/: make('fa-file-exclamation',  /**/ '$supplier$ requested a Change Order for $what$ in $programName$'),
    'File Added - PO'        /**/: make('fa-file-plus',         /**/ 'A file was added in $what$ for $programName$'),
    'PO Approved'            /**/: make('fa-file-check',        /**/ 'Purchase Order $what$ was approved for $supplier$ for $programName$'),
    'PO Cancelled'           /**/: make('fa-file-times',        /**/ 'Purchase Order $what$ was cancelled for $supplier$ for $programName$'),
    'PO Closed'              /**/: make('fa-envelope',          /**/ 'Purchase Order $what$ was closed for $supplier$ for $programName$'),
    'PO Created'             /**/: make('fa-file-plus',         /**/ 'Purchase Order $what$ was opened for $supplier$ for $programName$'),
    'PO Created from SOS'    /**/: make('fa-file-plus',         /**/ 'Purchase Order $what$ was opened for $supplier$ for $programName$'),
    'PO Rejected'            /**/: make('fa-file-times',        /**/ 'Purchase Order $what$ was declined for $supplier$ for $programName$'),
    'PO Declined'            /**/: make('fa-file-times',        /**/ 'Purchase Order $what$ was declined for $supplier$ for $programName$'),
    'Savings PO Cancelled'   /**/: make('fa-file-times',        /**/ 'Purchase Order $what$ was cancelled for $supplier$ for $programName$'),
    'Savings PO Closed'      /**/: make('fa-envelope',          /**/ 'Purchase Order $what$ was closed for $supplier$ for $programName$'),
    'Savings PO Created'     /**/: make('fa-file-plus',         /**/ 'Purchase Order $what$ was opened for $supplier$ for $programName$')
  },

  'Expense': {
    'Expense Approved'       /**/: make('fa-file-check',        /**/ 'Expense $what$ was approved for $supplier$ for $programName$'),
    'Expense Created'        /**/: make('fa-file-plus',         /**/ 'Expense $what$ was created for $programName$'),
    'Expense Rejected'       /**/: make('fa-file-times',        /**/ 'Expense $what$ was declined for $supplier$ for $programName$'),
    'Expense Declined'       /**/: make('fa-file-times',        /**/ 'Expense $what$ was declined for $supplier$ for $programName$')
  },

  'Program': {
    'File Added - Program'   /**/: make('fa-file-plus',         /**/ 'A file was added for $programName$'),
    'Program Cancelled'      /**/: make('fa-file-times',        /**/ '$programLabel$  $programName$ was cancelled'),
    'Program Created'        /**/: make('fa-file-plus',         /**/ '$programLabel$  $programName$ was created')
  },

  'Program Budget': {
    'Budget Approved'        /**/: make('fa-file-check',        /**/ 'Budget was approved for $programName$'),
    'Budget Rejected'        /**/: make('fa-file-times',        /**/ 'Budget was declined for $programName$'),
    'Budget Declined'        /**/: make('fa-file-times',        /**/ 'Budget was declined for $programName$'),
    'Budget Submitted'       /**/: make('fa-envelope',          /**/ 'Budget was submitted for $programName$')
  },

  'Payment': {
    'Credit Payment Remittance Invoice Generated'
                             /**/: make('fa-repeat-alt',        /**/ 'Credit request was initiated for $what$ from $supplier$ for $programName$'),
    'Payment Posted'         /**/: make('fa-money-bill',        /**/ 'Payment was posted to invoice $what$ to $supplier$ for $programName$'),
    'Payment Processed'      /**/: make('fa-check-circle',      /**/ 'Payment was processed for invoice $what$ to $supplier$ for $programName$'),
    'Payment Scheduled'      /**/: make('fa-calendar-alt',      /**/ 'Payment was scheduled for invoice $what$ to $supplier$ for $programName$')
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/RecentUpdates/map.js